import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';
import CTA from 'react-scale/components/elements/button';

import styles from './QualityAssurance.module.css';

const QualityAssurance = ({ bg, overtitle, title, subtitle, texts, cta /* overbody */ }) => (
  <Section bg={bg} relative id="quality-assurance">
    <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />
    <div className="grid gap-4 md:grid-cols-2">
      <div className="mb-10 lg:mb-0">
        <h3 className="mb-4 text-2xl text-white lg:text-4xl font-aeonik">Super Human Quality</h3>
        <div className="lg:pr-16 text-neutral-300 md:text-lg">
          {texts.map(txt => {
            const text = typeof txt === 'string' ? txt : txt.text;
            return (
              <p key={text} className="text-lg first:mb-8 last:mb-8">
                {text}
              </p>
            );
          })}
        </div>
        {cta && (
          <div className="mt-2 lg:mt-4">
            <CTA href="/sales" text="Book a Demo" type="secondary" />
          </div>
        )}
      </div>
      <div>
        <img
          className={cn(styles.imageTop, 'rounded-lg shadow-md mb-4 md:max-w-none')}
          src="/static/img/website/components/qa-metrics-1.svg"
          alt="Scale's Dashboard"
        />
        <img
          className={cn(styles.imageBottom, 'rounded-lg shadow-md md:max-w-none')}
          src="/static/img/website/components/qa-metrics-2.svg"
          alt="Scale's Dashboard"
        />
      </div>
    </div>
  </Section>
);

QualityAssurance.defaultProps = {
  bg: 'bg-black',
  overtitle: 'Quality Assurance',
  title: 'Best-In-Class Quality',
  subtitle: 'Industry leading quality datasets safe-guarded against ever-changing, messy data.',
  texts: [
    'AR & VR tasks submitted to the platform are first pre-labeled by our proprietary ML-model, then manually reviewed by highly trained workers depending on the ML model confidence scores. All tasks receive additional layers of both human and ML-driven checks.',
    'The resulting accuracy is consistently higher than what a human or synthetic labeling approach can achieve independently.'
  ],
  overbody: 'Human-Level Accuracy'
};

export default QualityAssurance;
